import { configureStore } from '@reduxjs/toolkit';
import { alertReducer } from 'reducers/alert.slice';
import { authenticationReducer } from 'reducers/auth.slice';
import { customersReducer } from 'reducers/customer.slice';
import { invoicesReducer } from 'reducers/invoice.slice';
import { ordersReducer } from 'reducers/order.slice';
import { returnsReducer } from 'reducers/return.slice';
import { casesReducer } from 'reducers/case.slice';
import { creditMemosReducer } from 'reducers/credit.slice';
import { dtosReducer } from 'reducers/dto.slice';
import { pdfsReducer } from 'reducers/pdf.slice';
import { dellWarrantyReducer } from '../reducers/dellWarranty.slice';

export const store = configureStore({
    reducer: {
        authentication: authenticationReducer,
        alert: alertReducer,
        customers: customersReducer,
        invoices: invoicesReducer,
        orders: ordersReducer,
        returns: returnsReducer,
        cases: casesReducer,
        creditMemos: creditMemosReducer,
        dtos: dtosReducer,
        pdfs: pdfsReducer,
        dellWarranty: dellWarrantyReducer
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: {
            ignoreState: true,
            ignoreActions: true
        }
    })
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;